import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=04828aac&"
import script from "./ProductFilter.js?vue&type=script&lang=js&"
export * from "./ProductFilter.js?vue&type=script&lang=js&"
import style0 from "./ProductFilter.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductFilter.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fproductoverview%2FProductFilter%2FProductFilter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports